import styled, { css } from 'styled-components';
import { StyledTypography } from 'styles/common';
import { checkNewNavEnabled } from 'utils/helpers/featureFlags';

import { StyledIcon } from 'constants/icons';

export const StyledContainer = styled.div`
  width: 100%;
  grid-template-columns: 1.5fr 2fr;
  height: ${() => (checkNewNavEnabled() ? 'auto' : '100vh')};
  padding: ${() => (checkNewNavEnabled() ? '0' : '16px')};
  ${(props) =>
    props.center &&
    css`
      text-align: center;
    `};
`;

export const StyledTypography1 = styled(StyledTypography)`
  line-height: 1.4;
  margin-top: -5px;
`;

export const Logo = styled.img`
  height: 86px;
  width: 86px;
  border-radius: 4px;
  margin-top: 2px;
`;

export const FormContainer = styled.div`
  background: white;
  margin-top: 12px;
  border-radius: 8px;
  box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.24);
`;

export const FormHeading = styled(StyledTypography)`
  color: #333;
  font-size: 1.25rem;
  padding: 1.15rem 1.5rem 0.9rem 1.5rem;
`;

export const Separator = styled.hr`
  border: 0;
  height: 0;
  border-top: 1px solid #eaeaea;
`;

export const BodyContainer = styled.div`
  padding: 0.25rem 1.5rem 2rem 1.65rem;
`;

export const Icon = styled(StyledIcon)`
  color: #333;
  vertical-align: middle;
  margin-right: 0.75rem;
  margin-bottom: 2px;
  ${(props) =>
    props.rotate &&
    css`
      transform: rotate(-45deg);
    `}
`;
